type UnknownRecord = Record<string, unknown>;

const DASHBOARD_DEBUG_STORAGE_KEY = 'perare.debug.dashboards';

function readLocalStorage(key: string): string | null {
  try {
    if (typeof window === 'undefined' || !window?.localStorage) return null;
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function isDashboardDebugEnabled(): boolean {
  // Enable with: localStorage.setItem('perare.debug.dashboards', '1')
  // Disable with: localStorage.removeItem('perare.debug.dashboards')
  if (readLocalStorage(DASHBOARD_DEBUG_STORAGE_KEY) === '1') return true;

  // Auto-enable on local dev hosts to simplify debugging.
  // Safe guard: never auto-enable outside browser.
  try {
    if (typeof window === 'undefined') return false;
    const host = window.location?.hostname ?? '';
    return host === 'localhost' || host.endsWith('.local');
  } catch {
    return false;
  }
}

export function maskToken(value: string | null | undefined): string {
  if (!value) return '';
  const v = String(value);
  if (v.length <= 12) return `${v.slice(0, 3)}…${v.slice(-2)}`;
  return `${v.slice(0, 6)}…${v.slice(-4)}`;
}

export function safeStringify(value: unknown, maxLength = 1200): string {
  try {
    const json = JSON.stringify(value);
    if (json.length <= maxLength) return json;
    return `${json.slice(0, maxLength)}…`;
  } catch {
    return '[unserializable]';
  }
}

export function dashLog(message: string, meta?: UnknownRecord): void {
  if (!isDashboardDebugEnabled()) return;
  if (meta) {
    console.log(`[dashboard] ${message}`, meta);
  } else {
    console.log(`[dashboard] ${message}`);
  }
}

export function dashWarn(message: string, meta?: UnknownRecord): void {
  if (!isDashboardDebugEnabled()) return;
  if (meta) {
    console.warn(`[dashboard] ${message}`, meta);
  } else {
    console.warn(`[dashboard] ${message}`);
  }
}

export function dashError(message: string, meta?: UnknownRecord): void {
  if (!isDashboardDebugEnabled()) return;
  if (meta) {
    console.error(`[dashboard] ${message}`, meta);
  } else {
    console.error(`[dashboard] ${message}`);
  }
}

export function dashGroupCollapsed(title: string, meta?: UnknownRecord): void {
  if (!isDashboardDebugEnabled()) return;
  if (meta) {
    console.groupCollapsed(`[dashboard] ${title}`, meta);
  } else {
    console.groupCollapsed(`[dashboard] ${title}`);
  }
}

export function dashGroupEnd(): void {
  if (!isDashboardDebugEnabled()) return;
  console.groupEnd();
}


